'use client';

import { Heading } from '@depop/web-thrift-ui/Typography';
import { Panel } from '@depop/web-ui-kit/Panel';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import { GuestCheckoutSummaryEmpty } from './GuestCheckoutSummaryEmpty';
import { GuestCheckoutSummarySkeleton } from './GuestCheckoutSummarySkeleton';
import styles from './styles.module.css';

import { CheckoutOrderSummaryPanelV2 } from '@/app/[locale]/pay/components/CheckoutOrderSummaryPanelV2';
import { OrderSummaryAccordionWrapper } from '@/app/[locale]/pay/components/CheckoutOrderSummaryPanelV2/OrderSummaryAccordionWrapper';
import { formatOrderSummaryPrice } from '@/modules/checkout/helpers';
import { useGuestCheckoutSummary } from '@/modules/checkout/useGuestCheckoutSummary';
import { getCurrencySymbolFromCurrencyCode } from '@/modules/currencies/helpers';

export function GuestCheckoutSummary() {
  const t = useTranslations('checkout');
  const summary = useGuestCheckoutSummary();

  if (summary.status === 'pending') {
    return <GuestCheckoutSummarySkeleton />;
  }

  if (summary.status === 'empty') {
    return (
      <>
        <div
          className={clsx(
            styles.accordionWrapper,
            styles['accordionWrapper--empty']
          )}
          data-summary-empty="true"
        >
          <Panel
            className={styles.accordionPanel}
            id="checkout-summary-accordion"
          >
            <GuestCheckoutSummaryEmpty />
          </Panel>
        </div>

        <div className={styles.orderSummaryPanel} id="checkout-summary">
          <Panel
            className={styles.panel}
            id="checkout-summary-panel"
            as="aside"
          >
            <GuestCheckoutSummaryEmpty />
          </Panel>
        </div>
      </>
    );
  }

  const { products, checkoutSummary } = summary;

  const totalPrice = `${getCurrencySymbolFromCurrencyCode(
    products[0].price.currencyName
  )}${formatOrderSummaryPrice(checkoutSummary.total_price)}`;

  return (
    <>
      <div className={styles.accordionWrapper}>
        <Panel
          className={styles.accordionPanel}
          id="checkout-summary-accordion"
        >
          <OrderSummaryAccordionWrapper totalPrice={totalPrice}>
            <CheckoutOrderSummaryPanelV2
              hideTitle
              products={products}
              checkoutSummary={checkoutSummary}
              // hardcoded to true so we force the fees to appear in the breakdown
              // for combined checkout and sign up flow.
              canShipItem={true}
              withSoldOutHandling={true}
              withRemoveButton={true}
            />
          </OrderSummaryAccordionWrapper>
        </Panel>
      </div>

      <div className={styles.orderSummaryPanel} id="checkout-summary">
        <Panel className={styles.panel} id="checkout-summary-panel" as="aside">
          <Heading variant="md" className={styles.title}>
            {t('OrderSummaryTitle')}
          </Heading>
          <CheckoutOrderSummaryPanelV2
            products={products}
            checkoutSummary={checkoutSummary}
            canShipItem={true}
            withSoldOutHandling={true}
            withRemoveButton={true}
          />
        </Panel>
      </div>
    </>
  );
}
